import cn from "classnames";
import { ArrowLeft } from "@rshbintech.dboul/icons";
import { forwardRef } from "react";
import { Button } from "../../../../button";
import { ControlProps } from "./types";
import styles from "./styles.module.scss";

export const Control = forwardRef<HTMLButtonElement, ControlProps>(
  (
    { isHiddenControl, isSingleViewMode, isCenterMode, onClick, dataTestId },
    forwardedRef
  ) => (
    <Button
      htmlType="button"
      type="circle"
      className={cn(styles.control, {
        [styles.hidden]: isHiddenControl,
        [styles["single-view-mode"]]: isSingleViewMode,
        [styles["center-mode"]]: isCenterMode,
      })}
      onClick={onClick}
      dataTestId={`${dataTestId}-control`}
      ref={forwardedRef}
    >
      <ArrowLeft />
    </Button>
  )
);
